import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1cea28ff&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BFormGroup, BCol, BButton, BRow, BForm} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BFormGroup, BCol, BButton, BRow, BForm})
    

export default component.exports